export function isChosenForSampling(): boolean {
    if (window.matchMedia('only screen and (max-width: 760px)').matches) {
        return false;
    }

    let samplingValueString = localStorage.getItem('bri|sampling');
    if (!samplingValueString) {
        samplingValueString = `${Math.random() * 100}`;
        localStorage.setItem('bri|sampling', samplingValueString);
    }
    return (
        +samplingValueString < SAMPLING_PERCENTAGE &&
        +samplingValueString < UNRESTRAINT_PERCENTAGE
    );
}
